import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';

// @ts-expect-error migrate upstream dependency
import { getDashboardReports } from 'dashboard-lib/public/dashboard/dashboard-logic';
import useCanEditQuickFilter from './hooks/useCanEditQuickFilter';
import { getReportDataSourceUsages } from '../../../../lib/dashboardFilters/dataSourceHelpers';
import { selectHasQuickFilterApplied } from '../../../../ducks/quick-filters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GenerateQuickFilterGroupsPopoverButton = ({
  dashboard,
  handleTogglePopover
}) => {
  const hasQuickFilterApplied = useSelector(selectHasQuickFilterApplied);
  const reports = getDashboardReports(dashboard);
  const userHasQuickFilterEditPermission = useCanEditQuickFilter({
    dashboard
  });
  const dataSources = Object.keys(getReportDataSourceUsages({
    reports
  }));
  const isQuickFilterPopoverButtonDisabled = !userHasQuickFilterEditPermission || dataSources.length === 0;
  const getDisabledMessage = () => {
    if (!userHasQuickFilterEditPermission) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.permissionConfig"
      });
    } else if (dataSources.length === 0) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboardHeader.dashboardFilters.allFilters.noFilterableReports"
      });
    }
    return undefined;
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !isQuickFilterPopoverButtonDisabled,
    title: getDisabledMessage(),
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: handleTogglePopover,
      disabled: isQuickFilterPopoverButtonDisabled,
      "data-test-id": "generate-quick-filter-group-popover-button",
      size: "medium",
      className: "m-right-4",
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [hasQuickFilterApplied ? /*#__PURE__*/_jsx(UIIcon, {
          name: "edit",
          "data-test-id": "generate-quick-filter-group-popover-edit-icon"
        }) : /*#__PURE__*/_jsx(UIIcon, {
          name: "add",
          "data-test-id": "generate-quick-filter-group-popover-add-icon"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quickFilter.panel.title"
        })]
      })
    })
  });
};